var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proceed-btn-wrap"},[_c('button',{staticClass:"proceed-btn",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"btn-text"},[_vm._v("Proceed")]),_c('span',{staticClass:"btn-bg-shape"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }